module.exports = __webpack_public_path__ + "img/icon-chapters.17bb8220.png";